import { render, staticRenderFns } from "./CreditAccountStatement.vue?vue&type=template&id=dfe48ee2&scoped=true&"
import script from "./CreditAccountStatement.vue?vue&type=script&lang=js&"
export * from "./CreditAccountStatement.vue?vue&type=script&lang=js&"
import style0 from "./CreditAccountStatement.vue?vue&type=style&index=0&id=dfe48ee2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe48ee2",
  null
  
)

export default component.exports